import VerifyCodeOtpContainer from './VerifyCodeOtpContainer';

export default VerifyCodeOtpContainer;
